import React, {useEffect, useState} from "react";
import Select from "antd/lib/select";

export function DbsChannelComponent (props) {

    const { Option } = Select;

    let HONGKONG = 'Hong Kong';
    const channelList = [HONGKONG,'Singapore'];

    let AUSTRALIA = 'Australia';



    return (
        <>
            <Select style={{ width: 120 }} onSelect={(value, event) => props.handleOnVaLocationChange(value, event)}>
                <Option value={HONGKONG} disabled={props.hasDBSHKVA}>{HONGKONG}</Option>
                <Option value={AUSTRALIA} disabled={props.hasFlashFXVA}>{AUSTRALIA}</Option>
                <Option value={'Singapore'} disabled={true}>{'Singapore'}</Option>
            </Select>
        </>
    )
}
